import React, { useState } from "react";
import Modal from "react-modal";
import './index.css';

const UserInfoForm = ({ onSpin, isShow, onClose }) => {
    const [playerName, setPlayerName] = useState("");
    const [phone, setPhone] = useState("");
    const [address, setAddress] = useState("");
    const [noCCCD, setNoCCCD] = useState("");
    const [vehical, setVehical] = useState("");
    const [error, setError] = useState("");
    const [branch, setBranch] = useState("Cơ sở 1: 86 Lê Duẩn - tt Khe Sanh"); // Thêm state cho cơ sở



    const handleSpin = () => {
        if (!playerName || !phone || !address || !branch) {
            setError("Vui lòng nhập đầy đủ thông tin trước khi quay!");
            return;
        }
        setError("");
        onSpin({ playerName, phone, address, vehical, noCCCD, branch });
    };

    return (
        <div className="modal-overlay">
            <Modal
                isOpen={isShow}
                className="modal-content"
                overlayClassName="modal-overlay"
            >
                <button className="modal-close" onClick={onClose}>✖</button>

                <h2>Nhập Thông Tin Người Quay</h2>
                <input
                    className="user-input"
                    type="text"
                    placeholder="Tên người quay"
                    value={playerName}
                    onChange={(e) => setPlayerName(e.target.value)}
                />
                <input
                    className="user-input"
                    type="text"
                    placeholder="Số điện thoại"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                />
                <input
                    className="user-input"
                    type="text"
                    placeholder="Số CCCD"
                    value={noCCCD}
                    onChange={(e) => setNoCCCD(e.target.value)}
                />
                <input
                    className="user-input"
                    type="text"
                    placeholder="Loại xe đã mua"
                    value={vehical}
                    onChange={(e) => setVehical(e.target.value)}
                />
                <textarea
                    className="user-input"
                    type="text"
                    placeholder="Địa chỉ"
                    value={address}
                    onChange={(e) => setAddress(e.target.value)}
                />

                {/* Dropdown chọn cơ sở */}
                <select
                    className="user-input"
                    value={branch}
                    onChange={(e) => setBranch(e.target.value)}
                >
                    <option value="Cơ sở 1: 86 Lê Duẩn - tt Khe Sanh">Cơ sở 1: 86 Lê Duẩn - tt Khe Sanh</option>
                    <option value="Cơ sở 2: 172 Lê Duẩn - tt Khe Sanh">Cơ sở 2: 172 Lê Duẩn - tt Khe Sanh</option>
                    <option value="Cơ sở 3: 115 Lê Duẩn - tt Khe Sanh">Cơ sở 3: 115 Lê Duẩn - tt Khe Sanh</option>
                    <option value="Cơ sở 4: 03 Lý Thường Kiệt, tt Lao Bảo">Cơ sở 4: 03 Lý Thường Kiệt, tt Lao Bảo</option>
                    <option value="Cơ sở 5: 509 Lê Duẩn, tt Krông-Klang Đakrông">Cơ sở 5: 509 Lê Duẩn, tt Krông-Klang Đakrông</option>
                </select>
                {error && <p className="error-text">{error}</p>}

                {/* Nút xác nhận */}
                <button onClick={handleSpin}>Lưu</button>

            </Modal>
        </div>
    );
};

export default UserInfoForm;
